import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const createNewTestOrder = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.CREATE_NEW_TEST_ORDER.METHOD](APIConfig.CREATE_NEW_TEST_ORDER.URL, payload);
}
const getTestOrderDetails = (testOrderId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_TEST_ORDER_DETAILS.METHOD](APIConfig.GET_TEST_ORDER_DETAILS.URL(testOrderId), payload);
}
// const createPatient = (testOrderID: number, payload: any) => {
//     // @ts-ignore
//     return ApiService[APIConfig.CREATE_PATIENT.METHOD](APIConfig.CREATE_PATIENT.URL(testOrderID), payload);
// }
// const addPatientIntake = (testOrderID: number, payload: any) => {
//     // @ts-ignore
//     return ApiService[APIConfig.ADD_PATIENT_INTAKE.METHOD](APIConfig.ADD_PATIENT_INTAKE.URL(testOrderID), payload);
// }


// const addTestOrderBillingMode = (testOrderID: number, payload: any) => {
//     // @ts-ignore
//     return ApiService[APIConfig.ADD_TEST_ORDER_BILLING_DETAILS.METHOD](APIConfig.ADD_TEST_ORDER_BILLING_DETAILS.URL(testOrderID), payload);
// }

// const addTestOrderAccessionBarCodeDetails = (testOrderID: number, payload: any) => {
//     // @ts-ignore
//     return ApiService[APIConfig.ADD_TEST_ORDER_ACCESSION_BARCODE_DETAILS.METHOD](APIConfig.ADD_TEST_ORDER_ACCESSION_BARCODE_DETAILS.URL(testOrderID), payload);
// }

const markICD10CodesAsFavourite = (locationID: number, icdId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_FAVOURITE_ICD10_CODE.METHOD](APIConfig.ADD_FAVOURITE_ICD10_CODE.URL(locationID, icdId), payload);
}

const unFavouriteICDCode = (locationID: number, icdId: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.REMOVE_FAVOURITE_ICD10_CODE.METHOD](APIConfig.REMOVE_FAVOURITE_ICD10_CODE.URL(locationID, icdId), payload);
}

const uploadOrderAttachments = (testOrderID: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.UPLOAD_TEST_ORDER_ATTACHMENTS.METHOD](APIConfig.UPLOAD_TEST_ORDER_ATTACHMENTS.URL(testOrderID), payload,
        {'Content-Type': 'multipart/form-data'});
}

const uploadPatientAttachments = (testOrderID: number, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.UPLOAD_TEST_ORDER_PATIENT_ATTACHMENTS.METHOD](APIConfig.UPLOAD_TEST_ORDER_PATIENT_ATTACHMENTS.URL(testOrderID), payload,
        {'Content-Type': 'multipart/form-data'});
}

const getTestOrderAttachments = (testOrderID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_ORDER_ATTACHMENTS_LIST.METHOD](APIConfig.TEST_ORDER_ATTACHMENTS_LIST.URL(testOrderID), payload);
}
const getTestOrderPatientAttachments = (testOrderID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_ORDER_PATIENT_ATTACHMENTS_LIST.METHOD](APIConfig.TEST_ORDER_PATIENT_ATTACHMENTS_LIST.URL(testOrderID), payload);
}
const deleteTestOrderAttachment = (testOrderID: any, attachmentId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_TEST_ORDER_ATTACHMENTS.METHOD](APIConfig.DELETE_TEST_ORDER_ATTACHMENTS.URL(testOrderID, attachmentId), payload);
}
const deleteTestOrderPatientAttachment = (testOrderID: any, attachmentId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_TEST_ORDER_PATIENT_ATTACHMENTS.METHOD](APIConfig.DELETE_TEST_ORDER_PATIENT_ATTACHMENTS.URL(testOrderID, attachmentId), payload);
}

const addSample = (testOrderID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_SAMPLE.METHOD](APIConfig.ADD_SAMPLE.URL(testOrderID), payload);
}

const editSample = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EDIT_SAMPLE.METHOD](APIConfig.EDIT_SAMPLE.URL, payload);
}

const generateTokenForIntakeForm = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GENERATE_TOKEN_FOR_INTAKE_FORM.METHOD](APIConfig.GENERATE_TOKEN_FOR_INTAKE_FORM.URL(), payload);
}

const getTestOrderListSampleBillingModes = (testOrderID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_TEST_ORDER_LIST_SAMPLE_BILLING_MODES.METHOD](APIConfig.GET_TEST_ORDER_LIST_SAMPLE_BILLING_MODES.URL(testOrderID), payload);
}
const getTestOrderSampleList = (testOrderId:any,payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_TEST_ORDER_SAMPLE_LIST.METHOD](APIConfig.GET_TEST_ORDER_SAMPLE_LIST.URL(testOrderId), payload);
}

const getTestOrderSampleListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_TEST_ORDER_SAMPLE_LIST_LITE.METHOD](APIConfig.GET_TEST_ORDER_SAMPLE_LIST_LITE.URL, payload);
}

const downloadTestOrderCSV = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_ORDER_CSV_DOWNLOAD.METHOD](APIConfig.TEST_ORDER_CSV_DOWNLOAD.URL, payload);
}

const bulkUploadTestOrder = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.BULK_UPLOAD_TEST_ORDER.METHOD](APIConfig.BULK_UPLOAD_TEST_ORDER.URL, payload);
}

const getBulkOrderDetails = (bulkOrderId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_BULK_ORDER_DETAILS.METHOD](APIConfig.GET_BULK_ORDER_DETAILS.URL(bulkOrderId), payload);
}

const addTestOrderSampleCashPaymentList = (testOrderID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_TEST_ORDER_SAMPLES_CASH_PAYMENT.METHOD](APIConfig.ADD_TEST_ORDER_SAMPLES_CASH_PAYMENT.URL(testOrderID), payload);
}

const submitPanelInsurance = (testOrderID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SUBMIT_PANEL_INSURANCE.METHOD](APIConfig.SUBMIT_PANEL_INSURANCE.URL(testOrderID), payload);
}

const placeOrder = (testOrderID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.PLACE_ORDER.METHOD](APIConfig.PLACE_ORDER.URL(testOrderID), payload);
}

const generateBulkOrders = (bulkOrderId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GENERATE_ORDERS.METHOD](APIConfig.GENERATE_ORDERS.URL(bulkOrderId), payload);
}

const getBulkTestOrderListCount = (bulkPatientId: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_BULK_TEST_ORDER_LIST_COUNT.METHOD](APIConfig.GET_BULK_TEST_ORDER_LIST_COUNT.URL(bulkPatientId));
}
const getBulkTestOrderGeneratedCount = (bulkPatientId: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_BULK_TEST_ORDER_GENERATED_COUNT.METHOD](APIConfig.GET_BULK_TEST_ORDER_GENERATED_COUNT.URL(bulkPatientId));
}

const removeSample = (testOrderId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.REMOVE_TEST_ORDER_SAMPLE.METHOD](APIConfig.REMOVE_TEST_ORDER_SAMPLE.URL(testOrderId), payload);
}

const deleteTestOrder = (testOrderId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_TEST_ORDER.METHOD](APIConfig.DELETE_TEST_ORDER.URL(testOrderId), payload);
}

const addConsentForm = (testOrderId: any, sampleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_CONSENT_FORM.METHOD](APIConfig.ADD_CONSENT_FORM.URL(testOrderId, sampleId), payload);
}
const deleteConsentForm = (testOrderId: any, sampleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DELETE_CONSENT_FORM.METHOD](APIConfig.DELETE_CONSENT_FORM.URL(testOrderId, sampleId), payload);
}
const downloadSampleListCsv = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DOWNLOAD_SAMPLE_LIST_CSV.METHOD](APIConfig.DOWNLOAD_SAMPLE_LIST_CSV.URL, payload);
}
const sendConsentFormLinkToPatient = (testOrderId: any, sampleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SEND_CONSENT_FORM_LINK_TO_PATIENT.METHOD](APIConfig.SEND_CONSENT_FORM_LINK_TO_PATIENT.URL(testOrderId, sampleId), payload);
}
const sendIntakeFormLinkToPatient = (testOrderId: any, sampleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SEND_INTAKE_FORM_LINK_TO_PATIENT.METHOD](APIConfig.SEND_INTAKE_FORM_LINK_TO_PATIENT.URL(testOrderId, sampleId), payload);
}
const getSampleDetails = (testOrderId: any, sampleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_SAMPLE_DETAILS.METHOD](APIConfig.GET_SAMPLE_DETAILS.URL(testOrderId, sampleId), payload);
}
const getSampleLogs = (sampleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_SAMPLE_LOGS.METHOD](APIConfig.GET_SAMPLE_LOGS.URL(sampleId), payload);
}
const getTestOrderLogs = (testOrderId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_TEST_ORDER_LOGS.METHOD](APIConfig.GET_TEST_ORDER_LOGS.URL(testOrderId), payload);
}

const generateBarcode = (testId:any,payload:any) =>{
    // @ts-ignore
    return ApiService[APIConfig.GENERATE_BARCODE.METHOD](APIConfig.GENERATE_BARCODE.URL(testId),payload);
}

const TestOrderService = {
    getTestOrderDetails,
    createNewTestOrder,
    addSample,
    addConsentForm,
    sendIntakeFormLinkToPatient,
    deleteConsentForm,
    sendConsentFormLinkToPatient,
    uploadOrderAttachments,
    deleteTestOrderAttachment,
    getTestOrderAttachments,
    downloadTestOrderCSV,
    markICD10CodesAsFavourite,
    unFavouriteICDCode,
    getTestOrderPatientAttachments,
    uploadPatientAttachments,
    deleteTestOrderPatientAttachment,
    getTestOrderListSampleBillingModes,
    generateTokenForIntakeForm,
    addTestOrderSampleCashPaymentList,
    submitPanelInsurance,
    placeOrder,
    getTestOrderSampleList,
    getTestOrderSampleListLite,
    editSample,
    bulkUploadTestOrder,
    getBulkOrderDetails,
    generateBulkOrders,
    getBulkTestOrderListCount,
    getBulkTestOrderGeneratedCount,
    removeSample,
    deleteTestOrder,
    downloadSampleListCsv,
    getSampleDetails,
    getSampleLogs,
    getTestOrderLogs,
    generateBarcode
}

export default TestOrderService;

